import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export interface AccordionItem {
  id: string;
  title: string;
  content: React.ReactNode;
}
interface AccordionProps {
  items: AccordionItem[];
  className?: string;
}
export function Accordion({
  items,
  className = ''
}: AccordionProps) {
  const [openId, setOpenId] = useState<string | null>(null);
  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };
  return <div className={`space-y-4 ${className}`} data-id="element-18822">
      {items.map(item => {
      const isOpen = openId === item.id;
      return <div key={item.id} className="border border-slate-200 rounded-2xl bg-white overflow-hidden transition-all duration-200" data-id="element-18823">
            <button onClick={() => toggle(item.id)} className="w-full flex justify-between items-center p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-inset" aria-expanded={isOpen} data-id="element-18824">
              <span className="font-medium text-slate-900" data-id="element-18825">{item.title}</span>
              <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-18826" />
            </button>
            <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-18827">
              <div className="text-slate-600 text-sm leading-relaxed" data-id="element-18828">
                {item.content}
              </div>
            </div>
          </div>;
    })}
    </div>;
}